const fontConfig = {
  cdnBaseUrl: {
    development: 'https://assets.zagforward.com',
    test: 'https://assets.carvanatech.com',
    uat: 'https://resources.cvuat.com',
    prod: 'https://assets.cvnaassets.com'
  }
};

export type IEnvironmentTypes = keyof typeof fontConfig.cdnBaseUrl;

export default fontConfig;
